/**
 * How an exception label's Prozo status is presented.
 *
 * The list shows one pill per label rather than a separate Status column, since
 * the status and the tracking link answer the same question: where is this
 * parcel? Clicking the pill opens Prozo's own tracking page.
 */

/**
 * Which visual family a ShipmentProgress value belongs to.
 *
 * Green is the requested default for a live, healthy shipment. Two states must
 * not be green or the pill would lie: a label with no scan yet (progress is
 * blank by default, a real state), and a cancelled one.
 */
export function statusTone(row) {
  if (!row) return 'isNeutral';
  if (row.status === 'cancelled') return 'isDead';

  const progress = row.progress || '';
  if (!progress) return 'isNeutral';

  // RTO, lost, damaged, failed pickup/delivery — still worth showing, but not
  // as "all is well".
  if (
    progress.startsWith('rto') ||
    progress.startsWith('cancelled') ||
    ['lost', 'damaged', 'failed_delivery', 'pickup_failed', 'not_serviceable',
     'shipment_delayed', 'shipment_held', 'contact_customer_care'].includes(progress)
  ) {
    return 'isTrouble';
  }
  return 'isLive';
}

/**
 * What the pill reads.
 *
 * Falls through the mapped label, then Prozo's own wording, then the raw code —
 * so an unmapped status shows as something rather than an empty pill.
 */
export function statusLabel(row) {
  if (!row) return '—';
  if (row.status === 'cancelled') return 'Cancelled';
  return (
    row.progress_label ||
    row.progress_raw_label ||
    row.progress_raw_code ||
    'Awaiting first scan'
  );
}
